const MaldivesSvg = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_4152_111832)">
      <path
        d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z"
        fill="#D80027"
      />
      <path d="M6.95654 10.4346H33.0435V29.565H6.95654V10.4346Z" fill="#6DA544" />
      <path
        d="M23.2212 25.6517C20.0996 25.6517 17.569 23.1211 17.569 19.9995C17.569 16.878 20.0996 14.3473 23.2212 14.3473C24.1945 14.3473 25.1104 14.5934 25.9099 15.0267C24.6556 13.8001 22.9404 13.043 21.0473 13.043C17.2054 13.043 14.0908 16.1575 14.0908 19.9995C14.0908 23.8414 17.2054 26.9559 21.0473 26.9559C22.9404 26.9559 24.6557 26.1988 25.9099 24.9722C25.1104 25.4056 24.1945 25.6517 23.2212 25.6517Z"
        fill="#F0F0F0"
      />
    </g>
    <defs>
      <clipPath id="clip0_4152_111832">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default MaldivesSvg;
